import * as sdk from 'matrix-js-sdk';
const store = {
    client: sdk.createClient({ baseUrl: '' }),
    phrase: '',
    userImages: [],
    events: [],
};
export default store;
